module.exports = __webpack_public_path__ + "img/procesio.9e66d47c.png";